const HN = {
  countryConfig: {
    accountTypeBankDetails: {
      label: "bankDetails.accountTypeBankDetails",
      visible: true,
      required: true,
    },
    accountHolderDocNumber: {
      label: "bankDetails.documentCedula",
      required: true,
    },
    IBAN: {
      visible: false,
      required: false,
    },
    accountNumber: {
      label: "bankDetails.accountNumber",
      visible: true,
      required: true,
    },
    swift: {
      label: "bankDetails.swift",
      visible: true,
      required: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { HN };
